import { render } from "./holiday-modal.vue?vue&type=template&id=15944bc0"
import script from "./holiday-modal.vue?vue&type=script&lang=js"
export * from "./holiday-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__